<template>
    <v-container class="d-flex" justify-center >
        <v-layout column justify-center>
            <v-flex d-flex>
                <v-progress-circular
                :rotate="270"
                :size="100"
                :width="15"
                :value="value"
                :color="color"
            >{{ value }}{{symbol}}</v-progress-circular>
            </v-flex>            
            <v-flex center class="text-xs-center">
                <h4>{{caption}}</h4>
            </v-flex>
        </v-layout>
    </v-container>

</template>
<script>
export default{
    props:{
        value: {
            required: true,
            
        },
        color: {
            type: String,
            default: 'secondary'
        },
        caption: {
            type: String            
        },
        symbol: {
            type: String
        }
    }
}
</script>